import { Menu, X, ChevronRight, Shield, Heart, Award, Users, Phone, Mail, Clock } from "lucide-react";
import { useState } from "react";
import './index.css';

export default function Apple() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  return (
    <div className="min-h-screen bg-white">
      {/* Navigation */}
      <header className="bg-white shadow-md sticky top-0 z-50">
  {/* Announcement bar */}
  <div className="bg-gradient-to-r from-[#002D62] to-[#0077B6] text-white text-center py-2 text-sm">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <span className="font-semibold mr-2">Limited Time:</span> Get up to 30% off your first year of coverage. 
      <a href="/promotion" className="font-bold underline ml-1 hover:text-blue-100 transition-colors">Learn more</a>
    </div>
  </div>
  
  <div className="max-w-9xl mx-auto px-4 sm:px-6 lg:px-8">
    <div className="flex justify-between h-20">
      <div className="flex items-center">
        <div className="flex-shrink-0 flex items-center">
          <div className="mr-2 text-[#0077B6]">
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" className="w-8 h-8">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
            </svg>
          </div>
          <span className="text-2xl font-extrabold bg-gradient-to-r from-[#002D62] to-[#0077B6] bg-clip-text text-transparent">Optimal Actuarion</span>
        </div>
        <nav className="hidden md:ml-10 md:flex md:space-x-8">
          <a href="/" className="text-[#002D62] font-bold border-b-2 border-[#0077B6] px-1 pt-2 pb-1 transition-colors">Home</a>
          <a href="/#/about" className="text-gray-700 hover:text-[#002D62] font-medium px-1 pt-2 pb-1 border-b-2 border-transparent hover:border-[#0077B6] transition-colors">About Us</a>
          <a href="/#/services" className="text-gray-700 hover:text-[#002D62] font-medium px-1 pt-2 pb-1 border-b-2 border-transparent hover:border-[#0077B6] transition-colors">Services</a>
          <a href="/#/quote" className="text-gray-700 hover:text-[#002D62] font-medium px-1 pt-2 pb-1 border-b-2 border-transparent hover:border-[#0077B6] transition-colors">Get a Quote</a>
          <a href="/#/faqs" className="text-gray-700 hover:text-[#002D62] font-medium px-1 pt-2 pb-1 border-b-2 border-transparent hover:border-[#0077B6] transition-colors">FAQs</a>
          <a href="/#/testimonials" className="text-gray-700 hover:text-[#002D62] font-medium px-1 pt-2 pb-1 border-b-2 border-transparent hover:border-[#0077B6] transition-colors">Testimonials</a>
          <a href="/#/contact" className="text-gray-700 hover:text-[#002D62] font-medium px-1 pt-2 pb-1 border-b-2 border-transparent hover:border-[#0077B6] transition-colors">Contact</a>
        </nav>
      </div>
      <div className="flex items-center">
        <div className="hidden md:flex md:items-center md:space-x-4">
          <a href="/login" className="text-[#002D62] font-medium hover:text-[#0077B6] mr-4 transition-colors">Login</a>
          <a href="/quote" className="bg-gradient-to-r from-[#0077B6] to-[#00A8E8] text-white px-6 py-3 rounded-md font-bold hover:shadow-lg transform hover:-translate-y-0.5 transition-all duration-200">
            Get a Free Quote
          </a>
        </div>
        <div className="flex md:hidden">
          <button
            type="button"
            className="text-gray-700 hover:text-[#002D62] transition-colors"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            aria-expanded={mobileMenuOpen}
          >
            {mobileMenuOpen ? (
              <X className="h-6 w-6" />
            ) : (
              <Menu className="h-6 w-6" />
            )}
          </button>
        </div>
      </div>
    </div>
  </div>

  {/* Mobile menu */}
  {mobileMenuOpen && (
    <div className="md:hidden bg-white border-t border-gray-200 shadow-lg animate-fadeIn">
      <div className="pt-2 pb-4 space-y-1 px-4">
        <a href="/" className="block py-2 text-[#002D62] font-bold border-l-4 border-[#0077B6] pl-3">Home</a>
        <a href="/#/about" className="block py-2 text-gray-700 font-medium border-l-4 border-transparent hover:border-[#0077B6] hover:bg-gray-50 hover:text-[#002D62] pl-3 transition-colors">About Us</a>
        <a href="/#/services" className="block py-2 text-gray-700 font-medium border-l-4 border-transparent hover:border-[#0077B6] hover:bg-gray-50 hover:text-[#002D62] pl-3 transition-colors">Services</a>
        <a href="/#/quote" className="block py-2 text-gray-700 font-medium border-l-4 border-transparent hover:border-[#0077B6] hover:bg-gray-50 hover:text-[#002D62] pl-3 transition-colors">Get a Quote</a>
        <a href="/#/faqs" className="block py-2 text-gray-700 font-medium border-l-4 border-transparent hover:border-[#0077B6] hover:bg-gray-50 hover:text-[#002D62] pl-3 transition-colors">FAQs</a>
        <a href="/#/testimonials" className="block py-2 text-gray-700 font-medium border-l-4 border-transparent hover:border-[#0077B6] hover:bg-gray-50 hover:text-[#002D62] pl-3 transition-colors">Testimonials</a>
        <a href="/#/contact" className="block py-2 text-gray-700 font-medium border-l-4 border-transparent hover:border-[#0077B6] hover:bg-gray-50 hover:text-[#002D62] pl-3 transition-colors">Contact</a>
        <div className="pt-4 pb-2 space-y-2">
          <a href="/login" className="block text-center text-[#002D62] font-medium hover:text-[#0077B6] py-2 transition-colors">
            Login
          </a>
          <a href="/quote" className="w-full flex items-center justify-center bg-gradient-to-r from-[#0077B6] to-[#00A8E8] text-white px-4 py-3 rounded-md font-bold shadow-md transition-all hover:shadow-lg">
            Get a Free Quote
          </a>
        </div>
      </div>
    </div>
  )}
</header>

      <main>
        {/* Hero section */}
        <div className="relative bg-[#E8F1F9]">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 md:py-24">
            <div className="md:flex md:items-center md:space-x-8">
              <div className="md:w-1/2 mb-8 md:mb-0">
                <h1 className="text-4xl md:text-5xl font-bold text-[#002D62] leading-tight">
                  Insurance that puts <span className="text-[#0077B6]">people first</span>
                </h1>
                <p className="mt-4 text-lg text-gray-700 max-w-lg">
                  We provide affordable, reliable health and life insurance solutions with special focus on senior citizens and underserved communities.
                </p>
                <div className="mt-8 flex flex-col sm:flex-row space-y-4 sm:space-y-0 sm:space-x-4">
                  <a
                    href="/quote"
                    className="flex items-center justify-center px-5 py-3 border border-transparent text-base font-medium rounded-md text-white bg-[#0077B6] hover:bg-[#002D62]"
                  >
                    Get a Quote
                    <ChevronRight className="ml-2 h-5 w-5" />
                  </a>
                  <a
                    href="/contact"
                    className="flex items-center justify-center px-5 py-3 border border-[#0077B6] text-base font-medium rounded-md text-[#0077B6] bg-white hover:bg-gray-50"
                  >
                    Contact Us
                  </a>
                </div>
              </div>
              <div className="md:w-1/2">
                <div className="aspect-w-16 aspect-h-9 rounded-lg bg-gray-200 shadow-lg">
                  <div className="h-64 md:h-full w-full bg-gray-300 rounded-lg flex items-center justify-center">
                    <img src="insure-1.png" alt="Insurance Image" className="object-cover w-full h-full rounded-lg" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Features section */}
        <div className="py-12 bg-white">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center">
              <h2 className="text-3xl font-extrabold text-[#002D62] sm:text-4xl">
                Why Choose Optimal Actuarion?
              </h2>
              <p className="mt-4 max-w-2xl mx-auto text-lg text-gray-600">
                Our commitment to accessibility, affordability, and excellence sets us apart.
              </p>
            </div>

            <div className="mt-16">
              <div className="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-4">
                <div className="bg-[#E8F1F9] rounded-lg p-6 text-center">
                  <div className="flex justify-center">
                    <div className="p-3 rounded-full bg-[#0077B6] text-white">
                      <Shield className="h-8 w-8" />
                    </div>
                  </div>
                  <h3 className="mt-4 text-lg font-medium text-[#002D62]">Comprehensive Coverage</h3>
                  <p className="mt-2 text-gray-600">
                    Tailored insurance plans that provide complete protection for you and your family.
                  </p>
                </div>
                
                <div className="bg-[#E8F1F9] rounded-lg p-6 text-center">
                  <div className="flex justify-center">
                    <div className="p-3 rounded-full bg-[#0077B6] text-white">
                      <Heart className="h-8 w-8" />
                    </div>
                  </div>
                  <h3 className="mt-4 text-lg font-medium text-[#002D62]">Senior Citizen Focus</h3>
                  <p className="mt-2 text-gray-600">
                    Specialized plans designed with the unique needs of senior citizens in mind.
                  </p>
                </div>
                
                <div className="bg-[#E8F1F9] rounded-lg p-6 text-center">
                  <div className="flex justify-center">
                    <div className="p-3 rounded-full bg-[#0077B6] text-white">
                      <Users className="h-8 w-8" />
                    </div>
                  </div>
                  <h3 className="mt-4 text-lg font-medium text-[#002D62]">Community-Driven</h3>
                  <p className="mt-2 text-gray-600">
                    Supporting underserved communities with accessible insurance solutions.
                  </p>
                </div>
                
                <div className="bg-[#E8F1F9] rounded-lg p-6 text-center">
                  <div className="flex justify-center">
                    <div className="p-3 rounded-full bg-[#0077B6] text-white">
                      <Award className="h-8 w-8" />
                    </div>
                  </div>
                  <h3 className="mt-4 text-lg font-medium text-[#002D62]">Client-First Approach</h3>
                  <p className="mt-2 text-gray-600">
                    Transparent policies and exceptional customer service every step of the way.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Mission statement callout */}
        <div className="bg-[#002D62] text-white">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 md:py-16">
            <div className="text-center">
              <h2 className="text-2xl md:text-3xl font-bold">Our Mission</h2>
              <p className="mt-4 text-lg md:text-xl max-w-3xl mx-auto italic">
                "To transform the insurance industry by solving the challenges of shortchanging and inadequate benefits. We provide accessible, fair policies through strategic partnerships and client-first service."
              </p>
            </div>
          </div>
        </div>

        {/* Services preview */}
        <div className="py-12 bg-white">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="text-center">
              <h2 className="text-3xl font-extrabold text-[#002D62] sm:text-4xl">
                Our Services
              </h2>
              <p className="mt-4 max-w-2xl mx-auto text-lg text-gray-600">
                Comprehensive insurance solutions tailored to your unique needs.
              </p>
            </div>

            <div className="mt-10">
              <div className="grid grid-cols-1 gap-8 md:grid-cols-2">
                <div className="bg-[#F4F4F4] rounded-lg overflow-hidden shadow-md">
                  <div className="h-64 bg-gray-300 flex items-center justify-center">
                  <img src="health-insure.png" alt="Insurance Image" className="object-cover w-full h-full " />
                  </div>
                  <div className="p-6">
                    <h3 className="text-xl font-semibold text-[#002D62]">Health Insurance</h3>
                    <p className="mt-2 text-gray-600">
                      Comprehensive health coverage options designed to keep you and your family protected.
                    </p>
                    <a href="/services#health" className="mt-4 inline-flex items-center text-[#0077B6] font-medium">
                      Learn more
                      <ChevronRight className="ml-1 h-4 w-4" />
                    </a>
                  </div>
                </div>

                <div className="bg-[#F4F4F4] rounded-lg overflow-hidden shadow-md">
                  <div className="h-64 bg-gray-300 flex items-center justify-center">
                  <img src="life-insure.png" alt="Life Insurance Image" className="object-cover w-full h-full" />
                  </div>
                  <div className="p-6">
                    <h3 className="text-xl font-semibold text-[#002D62]">Life Insurance</h3>
                    <p className="mt-2 text-gray-600">
                      Secure your family's financial future with our flexible life insurance policies.
                    </p>
                    <a href="/services#life" className="mt-4 inline-flex items-center text-[#0077B6] font-medium">
                      Learn more
                      <ChevronRight className="ml-1 h-4 w-4" />
                    </a>
                  </div>
                </div>
              </div>

              <div className="mt-8 text-center">
                <a href="/services" className="inline-flex items-center px-6 py-3 border border-[#0077B6] text-base font-medium rounded-md text-[#0077B6] bg-white hover:bg-gray-50">
                  View All Services
                  <ChevronRight className="ml-2 h-5 w-5" />
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Call to action */}
        <div className="bg-[#E8F1F9]">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 md:py-16">
            <div className="md:flex md:items-center md:space-x-8">
              <div className="md:w-2/3 mb-6 md:mb-0">
                <h2 className="text-3xl font-bold text-[#002D62]">Ready to secure your future?</h2>
                <p className="mt-3 text-lg text-gray-700">
                  Get in touch with our experts today for a personalized insurance solution that fits your needs and budget.
                </p>
              </div>
              <div className="md:w-1/3 flex justify-center md:justify-end">
                <a href="/quote" className="w-full md:w-auto inline-flex items-center justify-center px-8 py-4 border border-transparent text-base font-medium rounded-md text-white bg-[#0077B6] hover:bg-[#002D62]">
                  Get a Free Quote
                </a>
              </div>
            </div>
          </div>
        </div>
      </main>

      {/* Footer */}
      <footer className="bg-[#002D62] text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            <div>
              <h3 className="text-xl font-bold mb-4">Optimal Actuarion LLC</h3>
              <p className="mb-4">Insurance solutions for everyone, with a special focus on senior citizens and underserved communities.</p>
              <div className="flex flex-col space-y-2">
                <a href="/about" className="hover:text-gray-300">About Us</a>
                <a href="/services" className="hover:text-gray-300">Services</a>
                <a href="/testimonials" className="hover:text-gray-300">Testimonials</a>
                <a href="/faqs" className="hover:text-gray-300">FAQs</a>
              </div>
            </div>
            
            <div>
              <h3 className="text-xl font-bold mb-4">Contact Information</h3>
              <div className="flex flex-col space-y-3">
                <div className="flex items-start">
                  <div className="flex-shrink-0 mt-1">
                    <Phone className="h-5 w-5 text-[#0077B6]" />
                  </div>
                  <div className="ml-3">
                    <p>972-891-8635</p>
                  </div>
                </div>
                <div className="flex items-start">
                  <div className="flex-shrink-0 mt-1">
                    <Mail className="h-5 w-5 text-[#0077B6]" />
                  </div>
                  <div className="ml-3">
                    <p>OptimalActuarion@gmail.com</p>
                  </div>
                </div>
                <div className="flex items-start">
                  <div className="flex-shrink-0 mt-1">
                    <Clock className="h-5 w-5 text-[#0077B6]" />
                  </div>
                  <div className="ml-3">
                    <p>Monday-Friday: 9:00 AM - 5:00 PM</p>
                  </div>
                </div>
              </div>
            </div>
            
            <div>
              <h3 className="text-xl font-bold mb-4">Office Locations</h3>
              <div className="mb-4">
                <p className="font-medium">Primary Office:</p>
                <p>3221 Finley Road,</p>
                <p>Irving, TX 75062</p>
              </div>
              <div>
                <p className="font-medium">Business Address:</p>
                <p>4020 N MacArthur Blvd,</p>
                <p>Ste 122 #7156,</p>
                <p>Irving, TX 75038</p>
              </div>
            </div>
          </div>
          
          <div className="mt-8 pt-8 border-t border-gray-700">
            <p className="text-center text-sm">© {new Date().getFullYear()} Optimal Actuarion LLC. All rights reserved.</p>
          </div>
        </div>
      </footer>
    </div>
  );
}